import type { ComponentProps } from 'react';
// components
import HubertCombobox from 'components/HubertUI/HubertCombobox';
// hooks
import { useGetAllClientsQuery } from 'rtk/query/apis/clients';
//types
import Loading from 'components/common/Loading';
import IsAxiosError from 'components/common/IsAxiosError';

interface Props extends ComponentProps<'div'> {
  isMulti?: boolean;
  value?: string | string[];
  onValueChange?: (value: string | string[]) => void;
  disabled?: boolean;
  triggerClassName?: string;
  contentClassName?: string;
}

const ClientCombobox = ({
  isMulti = false,
  onValueChange,
  value,
  disabled = false,
  triggerClassName,
  contentClassName,
  ...props
}: Props) => {
  const { data, isLoading, isFetching, isError, error } = useGetAllClientsQuery();

  if (isLoading || isFetching) {
    return <Loading label="clients" />;
  }

  if (isError) {
    return <IsAxiosError error={error} />;
  }

  if (!data) {
    return null;
  }

  return (
    <div {...props}>
      <HubertCombobox
        itemName="client/s"
        isMulti={isMulti}
        items={data.clients.map((x) => {
          return { ...x, label: x.org_name, value: x._id };
        })}
        onValueChange={onValueChange}
        value={value}
        disabled={disabled}
        triggerClassName={triggerClassName}
        contentClassName={contentClassName}
      />
    </div>
  );
};

export default ClientCombobox;
